/**
 * Shared types/constants for EEGViewer chrome layers.
 * Kept out of EEGViewer.tsx so lazy EEGViewerDeferredChrome does not
 * statically import the orchestrator (which would defeat code-splitting).
 */

export type ConsensusResolutionMethod = "majority" | "senior" | "committee";

export type FloatingToolbarPosition =
  | "top-right"
  | "top-left"
  | "bottom-right"
  | "bottom-left";

export type AnnotationCategoryFilter = "all" | "clinical" | "technical_imported";

export type ChannelRegionKey =
  | "frontal"
  | "temporal"
  | "central"
  | "parietal"
  | "occipital";

export const EMPTY_CONSENSUS_RECOMMENDATIONS: string[] = [];

export const CHANNEL_REGION_OPTIONS: Array<{
  key: ChannelRegionKey;
  label: string;
}> = [
  { key: "frontal", label: "Frontal" },
  { key: "temporal", label: "Temporal" },
  { key: "central", label: "Central" },
  { key: "parietal", label: "Parietal" },
  { key: "occipital", label: "Occipital" },
];
